import React from 'react'

const DocumentIcon = () => {
  return (
    <svg viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg" class="css-satgqh"
    className='h-5 w-5'><path d="M10.367 1.223v2.73h2.731l-2.73-2.73Z" fill="currentColor"></path><path d="M9.566 5.554a.8.8 0 0 1-.8-.8v-4h-5.6a2.403 2.403 0 0 0-2.4 2.4v11.2a2.403 2.403 0 0 0 2.4 2.4h8a2.403 2.403 0 0 0 2.4-2.4v-8.8h-4Zm-4.8 0h2.4a.8.8 0 1 1 0 1.6h-2.4a.8.8 0 1 1 0-1.6Zm4.8 8h-4.8a.8.8 0 0 1 0-1.6h4.8a.8.8 0 0 1 0 1.6Zm0-3.2h-4.8a.8.8 0 0 1 0-1.6h4.8a.8.8 0 0 1 0 1.6Z" fill="currentColor"></path></svg>
  )
}

export default DocumentIcon